import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Col, Row } from 'react-bootstrap';
import TableComponent from '../../../components/shared/TableComponent';

import isUnderwriter from '../../../utils/is-underwriter'

export class UserList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            options: {
                defaultSortName: 'email',
                defaultSortOrder: 'asc',
                pageStartIndex: 1,
                paginationSize: 3,
                sizePerPage: 10
            },
            title: 'Brokers'
        };

        this.actionButtonsCellFormatter = this.actionButtonsCellFormatter.bind(this);
        this.adminCellFormatter = this.adminCellFormatter.bind(this);
        this.handleEditUser = this.handleEditUser.bind(this);
        this.handleDisableUser = this.handleDisableUser.bind(this);
        this.handleEnableUser = this.handleEnableUser.bind(this);
        this.handleRevokeUser = this.handleRevokeUser.bind(this);
        this.lastOnlineCellFormatter = this.lastOnlineCellFormatter.bind(this);
        this.statusCellFormatter = this.statusCellFormatter.bind(this);
    }

    actionButtonsCellFormatter(cell, row) {
        return (
            <div className="updateColumn">
                {this.canEditUser(row, this.props.user) && (
                  <Button onClick={() => { return this.handleEditUser(row) }}>
                    Edit
                  </Button>
                )}
                {this.canEnableUser(row, this.props.user) && (
                  <Button onClick={() => { return this.handleEnableUser(row) }}>
                    Enable
                  </Button>
                )}
                {this.canDisableUser(row, this.props.user) && (
                  <Button onClick={() => { return this.handleDisableUser(row) }}>
                    Disable
                  </Button>
                )}
                {this.canRevokeUser(row, this.props.user) && (
                  <Button onClick={() => { return this.handleRevokeUser(row) }}>
                    Revoke
                  </Button>
                )}
            </div>
        );
    }

    adminCellFormatter(cell, row) {
        return row.role.includes('admin') ? 'Yes' : '';
    }

    canDisableUser(row, user) {
        if (!user) return false;
        return row.status === 'active' && user.role.includes('broker');
    }

    canEditUser(row, user) {
        return true;
    }

    canEnableUser(row, user) {
        if (!user) return false;
        if (isUnderwriter(user)) {
            return ['disabled', 'revoked', 'deactivated'].includes(row.status);
        } else if (user.role.includes('broker')) {
            return row.status === 'disabled';
        }
    }

    canRevokeUser(row, user) {
        if (!user) return false;
        return ['active'].includes(row.status) && isUnderwriter(user);
    }

    componentDidMount() {
        // move the pagination totals to the top of the tables
        const totals = document.querySelectorAll('.pagination-total');

        function ancestor(el, cls) {
            while ((el = el.parentElement) && !el.classList.contains(cls));
            return el;
        }

        // workaround for IE!
        Array.prototype.forEach.call(totals, el => {
            const tableContainer = ancestor(el, 'react-bs-table-container'),
                toolbar = tableContainer.querySelector('.react-bs-table-tool-bar');

            if (toolbar) toolbar.appendChild(el);
        });
    }

    componentWillReceiveProps(props) {
        if (props.users) {
            this.setState({
                data: props.users
            });
        }
    }

    generateTableColumns() {
        return [
            { dataField: 'email', width: '22%', isKey: true, title: 'Email', isSortable: true },
            { dataField: 'firstName', title: 'First Name', isSortable: true, width: '11%' },
            { dataField: 'lastName', title: 'Last Name', isSortable: true, width: '11%' },
            {
                dataField: 'admin',
                width: '7.5%',
                title: 'Admin',
                dataFormat: this.adminCellFormatter
            },
            {
                isKey: false,
                title: 'Last Online',
                dataField: 'online',
                width: '150px',
                dataFormat: this.lastOnlineCellFormatter
            },
            {
                dataField: 'status',
                width: '7.5%',
                title: 'Status',
                dataFormat: this.statusCellFormatter
            },
            { width: '120px', dataFormat: this.actionButtonsCellFormatter }
        ];
    }

    handleDisableUser(row) {
        if (this.props.onDisableUser) {
            this.props.onDisableUser(row);
        }
    }

    handleEditUser(row) {
        if (this.props.onEditUser) {
            this.props.onEditUser(row);
        }
    }

    handleEnableUser(row) {
        if (this.props.onEnableUser) {
            this.props.onEnableUser(row);
        }
    }

    handleRevokeUser(row) {
        if (this.props.onRevokeUser) {
            this.props.onRevokeUser(row);
        }
    }


    lastOnlineCellFormatter(cell, row) {
        let m = moment(row.lastOnline);
        return <div>{m.isValid() ? m.format('M/D/YYYY h:mm a') : ''}</div>;
    }

    render() {
        return (
            <TableComponent
                title={this.state.title}
                options={this.state.options}
                data={this.state.data}
                columns={this.generateTableColumns()}
                customizedColumn={true}
            />
        );
    }

    statusCellFormatter(cell, row) {
        return row.status === 'active' ? (
            <div className="activeStatus">Active</div>
        ) : (
            <div className="disabledStatus">{row.status}</div>
        );
    }
}

UserList.propTypes = {
    onDisableUser: PropTypes.func,
    onEditUser: PropTypes.func,
    onEnableUser: PropTypes.func,
    onRevokeUser: PropTypes.func,
    user: PropTypes.object,
    users: PropTypes.array
};
